<div *ngIf="card.visible" class="card" [ngStyle]="cardStyle">
  <div class="inner-div" (click)="card?.onClick()">
    <span class="label-span">{{card.label}}</span> <span class="value-span">{{card.value}}</span>
  </div>
</div>
